<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Article Sub Category">
      <!-- <b-card-text>Job Category.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Category -->
            <b-col cols="12">
              <b-form-group label="Category" label-for="v-Category">
                <validation-provider #default="{ errors }"  name="Category">
                  <v-select id="v-Category" v-model="form.select_1" placeholder="Chose Category" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="CategoryOptions" :reduce="CategoryOptions => CategoryOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Sub Category -->
            <b-col cols="12">
              <b-form-group label="Sub Category" label-for="v-level">
                <validation-provider #default="{ errors }"  name="Sub Category" rules="required">
                  <b-form-input  id="v-Sub Category-name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Sub Category" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group label="Desc" label-for="v-profession">
                <validation-provider #default="{ errors }"  name="Desc" rules="required">
                  <b-form-input  id="v-Desc-name" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Desc" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { BOverlay, ValidationProvider, ValidationObserver, vSelect, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '', text_1: '',text_2: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ CategoryOptions: state => state.articleCategory.options}),
    select_1() {
      return this.form.select_1;
    }
  },
  created () {
    this.$store.dispatch('articleCategory/getAll')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('articleSubCategory/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('articleSubCategory/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.artc_ctgr_id
        this.form.text_1 = data.name
        this.form.text_2 = data.desc
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>